module.exports = __webpack_public_path__ + "img/gnt.43e33c9a.svg";